import { Navigate, Route } from "react-router-dom";
import AuthLayout from "../layouts/AuthLayout";
import Login from "../pages/auth/Login";
import { getToken, isValidJWT } from "../utils/token";
import RouteGuard from "./RouteGuard";

const publicRoutes = (
  <Route 
  element={<AuthLayout />}
  >
     <Route
      path="/"
      element={
        isValidJWT(getToken()) ? (
          <Navigate to="/dashboard" replace />

        ) : (
          <Login />

        )
      }
    />
  </Route>
);

export default publicRoutes;
